import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import { TagConstantes, CorrespondantStore } from "@digicerba/common";

@Injectable()
export class UserAdminAuthGuard implements CanActivate {

  constructor(private correspondantStore: CorrespondantStore, private router: Router) {
  }

  canActivate() {
    let isAdmin: boolean = this.correspondantStore.hasTag(TagConstantes.GESTIONNAIRE_CATALOGUE);

    if (!isAdmin) {
      this.router.navigate(['']);
      return false;
    } else {
        return true;
    }
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/admin.guard.ts